// extracted by mini-css-extract-plugin
module.exports =  {"root":"Ulefktb2sT5NYTfuHyqg","symbol":"VO0OhqmKreRWen82J9d5"};